import type React from 'react';

import { BannerWrapper } from '#src/app/shared/components/banners/layout';
import { Html } from '#src/app/shared/components/html';
import { useErrorText } from '#src/app/shared/hooks/error';

export const PetitionUnderReviewBanner: React.FC<EmptyProps> = () => {
	const text = useErrorText('petition_under_review');

	return (
		<BannerWrapper className="py-2">
			<Html html={text.header} size="large" />
			{/* noContentStyles + explicit paragraph margins replace the previous inline style overrides */}
			<Html html={text.main} noContentStyles className="mt-4 [&_p]:my-2 [&_p+p]:mt-2" />
		</BannerWrapper>
	);
};
